import api from '@utils/api'

import { cleanStorageAuth, setAuthAdmin } from '@utils/general'

import { SET_SESSION_PERMISSION } from '@constants/actionType'
import catalogPermissionWithViews from '@constants/catalogPermissionWithViews'
import { SECTION_DOCUMENT_ID, LANGUAGE_DEFAULT, DATA_USER } from '@constants/general'

export const getCompleteProfileUser = () => async (dispatch, _getState) => {
  const response = await api.getCompleteProfile()
  console.log('response --getCompleteProfile', response)
  // const response = {data: {"permisos":[{"id":8},{"id":10}],"secciones":{"navega":"SOME","lista":[{"id": 23}, {"id": 88}, {"id": 27} , {"id": 4}, {"id": 204}]},"paises":{"navega":"SOME","lista":[{"id": 10}, {"id": 7}]}}}
  if (!response?.status) {
    dispatch({
      type: SET_SESSION_PERMISSION,
      payload: response.data
    })
  } else {
    cleanStorageAuth()
  }
  return response;
};

export const validatePermissionView = (path) => async (dispatch, getState) => {
  // TRUE SI deja pasar FALSE NO deja
  // return true
  const { permisos } = getState().sessionPermission
  const { isFullAdmin } = getState().settings

  if (isFullAdmin) return true
  
  const hasPermissionView = catalogPermissionWithViews.reduce((accum, item) => {
      const findView = item.availablePaths.find(url => url.path === path)
      if (findView) accum.push({...findView, permissionId: item.permissionId})
      return accum
  }, [])

  if (hasPermissionView.length) {
      const hasPermission = hasPermissionView.reduce((validate, view) => {
        if (permisos.length) {
          const validateHasPermission = permisos.find(item => item.id === view.permissionId)
          if (validateHasPermission) validate = true
        }
        return validate
      }, false)
      return hasPermission
  } 
  // No existe algun permiso para la vista, es libre de navegar
  return true
}

export const validatePermissionAction = (permissionId) => (dispatch, getState) => {
  // TRUE SI deja pasar FALSE NO deja
  // return true
  const { permisos } = getState().sessionPermission
  const { isFullAdmin } = getState().settings
  
  if (isFullAdmin) return true

    if (permisos.length) {
        const hasPermission = permisos.find(item => item.id === permissionId)
        if (hasPermission) return true
    }
    return false
}

export const removeDisallowedSectionsTree = (categoriesSectionCatalog) => async  (dispatch, getState) => {
  const { secciones } = getState().sessionPermission
  if (secciones?.navega === "ALL") return categoriesSectionCatalog
  if (secciones?.navega === "SOME" && secciones?.lista.length) {
    const getParents = secciones.lista.map((item, index) => {
      // Encontrar a sus parents
      const getParent = validateGetParents(item.id, categoriesSectionCatalog)
      return getParent
    })
    const getSectionsSelected = secciones.lista.map((item) => (item.id))
    const uniqueParents = getParents.reduce((accum, item) => {
      item.map(opt => {
        if (!accum.includes(opt)) accum.push(opt)
      })
      return accum
    }, [])

    const newResult = await validateSecions([categoriesSectionCatalog], uniqueParents, getSectionsSelected)
    return newResult[0]
  }
  return {}
}

// @Se remueven secciones-paises que conincidan con el catalogo de paises
// @Si no coinciden se dejan visualizar al usuario
export const removeCountriesSectionsTree = (categoriesSectionCatalog) => async  (dispatch, getState) => {
  const { paises, secciones } = getState().sessionPermission
  const { countriesCatalog } = getState().catalogs

  if (categoriesSectionCatalog && paises?.navega === "SOME") {
    const getParents = secciones.lista.map((item, index) => {
      const getParent = validateGetParents(item.id, categoriesSectionCatalog)
      return getParent
    })
    const uniqueParents = getParents.reduce((accum, item) => {
      item.map(opt => {
        if (!accum.includes(opt)) accum.push(opt)
      })
      return accum
    }, [])
    const getSectionsSelected = secciones.lista.map((item) => (item.id))
    const getCountriesSelected = paises.lista.map((item) => (item.id))
    const hasSectionsDocuments = [...uniqueParents, ...getSectionsSelected ].includes(SECTION_DOCUMENT_ID)
    if (hasSectionsDocuments) {
      const findValue = searchNFTree(categoriesSectionCatalog, SECTION_DOCUMENT_ID);
      if (findValue && findValue.hijos.length) {
        findValue.hijos.map(sectionParent => {
          if (sectionParent.hijos) {
            const validateSectionsByCountry = dispatch(validateCountriesSectionsAllowed(sectionParent.hijos))
            console.log('validateSectionsByCountry', validateSectionsByCountry)
            // const validateSectionsByCountry = sectionParent.hijos.reduce((accum, children) => {
            //   const isCountry = countriesCatalog.find(countrie => countrie.nombre[LANGUAGE_DEFAULT] === children.nombre[LANGUAGE_DEFAULT].trim())
            //   if (isCountry) {
            //     const isPermitedCoutrie = getCountriesSelected.includes(isCountry.id)
            //     if (isPermitedCoutrie) accum.push(children)
            //   } else {
            //     console.warn('sin-coincidir', children.nombre[LANGUAGE_DEFAULT])
            //     accum.push(children)
            //   }
            //   return accum
            // }, [])
            sectionParent.hijos = validateSectionsByCountry
          }
        })
      }

    } else {
      return categoriesSectionCatalog
    }
  }
  return categoriesSectionCatalog
}

export const validateCountriesSectionsAllowed = (sections) => (dispatch, getState) => {
  const { paises } = getState().sessionPermission
  const { countriesCatalog } = getState().catalogs

  const getCountriesSelected = paises.lista.map((item) => (item.id))

  return sections.reduce((accum, children) => {
      const isCountry = countriesCatalog.find(countrie => countrie.nombre[LANGUAGE_DEFAULT] === children.nombre[LANGUAGE_DEFAULT].trim())
      if (isCountry) {
        const isPermitedCoutrie = getCountriesSelected.includes(isCountry.id)
        if (isPermitedCoutrie) accum.push(children)
      } else {
        console.warn('sin-coincidir', children.nombre[LANGUAGE_DEFAULT])
        accum.push(children)
      }
      return accum
    }, [])
}



// UTILS PERMISSIONS
const validateGetParents = (sectionId, secciones) => {
  const findValue = searchNFTree(secciones, sectionId);
  const fullParents = getParentsNFSections(findValue, [], secciones)
  return fullParents
}

const searchNFTree = (element, matchingId) => {
  if (element.id === matchingId) {
    return element;
  }
  if (element.hijos != null) {
    let i;
    let result = null;
    for (i = 0; result == null && i < element.hijos.length; i += 1) {
      result = searchNFTree(element.hijos[i], matchingId);
    }
    return result;
  }
  return null;
};

const getParentsNFSections = (findValue, array, secciones) => {
  if (findValue.id_padre) {
    const findValueP = searchNFTree(secciones, findValue.id_padre);
    if (findValueP.id_padre) array.unshift(findValueP.id)
    else array.unshift(findValueP.id)
    return getParentsNFSections(findValueP, array, secciones)
  }
  return array
}

// @Se remueven secciones no autorizadas.
// @Se validan secciones padres para que no se puedan seleccionar.
const validateSecions = (categoriesSectionCatalog, parents, sectionsSelected) => {
  const newResult = categoriesSectionCatalog.reduce((accum, item, index) => {
    const isExist = [...parents, ...sectionsSelected].includes(item.id)
    if (isExist) {
      if (sectionsSelected.includes(item.id)) {
        item.hijos = item.hijos
      } else if (item.hijos) {
        let validateHijos = validateSecions(item.hijos, parents, sectionsSelected)
        item.hijos = validateHijos
        item.selectable = false
      } else {
        delete item.hijos
        item.selectable = false
      }
      if (!item?.hijos || !item?.hijos.length) delete item.hijos
      if (!item?.children || !item?.children.length) delete item.children
      accum.push(item)
    }
    return accum
  }, [])
  return newResult
}
